﻿import { useEffect } from 'react';

import { SystemAdministrators } from 'pages/users/SystemAdministrators';
import { GMetrixLoader } from 'components/GMetrixLoader/GMetrixLoader';
import { UserDetailsContext, UsersContext } from 'pages/users/context';
import { NotificationContextProvider } from 'app/notifications';
import { TabsContextProvider } from 'components/Tabs/Tabs';
import { type UserPermissions } from 'pages/users/types';
import { UserDetail } from 'pages/users/UserDetail';
import { DefaultLayout } from 'components/layout';
import { useParams } from 'react-router-dom';
import { getIdFromURL } from 'utils/other';
import { PermissionsApi } from 'apis';
import { useSuperState } from 'hooks';
import { useIntl } from 'react-intl';
import { useApp } from 'app';

export type UsersContextValue = {
    currentPartnerId: number;
    permissions: UserPermissions;
}

export const SystemAdministratorsWrapper = () => {

    const { formatMessage } = useIntl();
    const [state, setState] = useSuperState({
        loading: true,
        permissions: null as UserPermissions
    });

    const { selectedPartner } = useApp();
    const currentPartnerId = getIdFromURL('partnerId')?.[0] ?? selectedPartner.id;

    const { id } = useParams();

    const { loading, permissions } = state;

    const fetchPermissions = async () => {

        try {

            const permissions = await PermissionsApi.Get('User');
            setState({
                loading: false,
                permissions
            });

        } catch (e) {

            console.error(e);
            setState({ loading: false });

        }

    };

    useEffect(() => {

        fetchPermissions();

    }, []);

    const context: UsersContextValue = {
        currentPartnerId,
        permissions
    };

    return (
        <DefaultLayout pageTitle={formatMessage({ id: 'administrators.018ac745', defaultMessage: 'Administrators', description: 'menu' })}>
            <UsersContext.Provider value={context}>
                <TabsContextProvider disableUrlSync context={UserDetailsContext}>
                    <NotificationContextProvider>
                        {loading ?
                            (
                                <div className="d-flex justify-content-center align-items-center" style={{ height: 'calc(100vh - 70px)' }}>
                                    <GMetrixLoader/>
                                </div>
                            )
                            :
                            (
                                id ? <UserDetail /> : <SystemAdministrators />
                            )
                        }
                    </NotificationContextProvider>
                </TabsContextProvider>
            </UsersContext.Provider>
        </DefaultLayout>
    );

};